import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const [requestCount, setRequestCount] = useState(0);
  const [chatCount, setChatCount] = useState(0);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [requestsRes, chatRes] = await Promise.all([
          axios.get('/api/items/my/requests'),
          axios.get('/api/chat/unread-count')
        ]);
        const requestTotal = Array.isArray(requestsRes.data) ? requestsRes.data.length : 0;
        const chatTotal = chatRes.data?.count || 0;
        setRequestCount(requestTotal);
        setChatCount(chatTotal);
      } catch (err) {
        setRequestCount(0);
        setChatCount(0);
      }
    };
    if (user) {
      fetchCounts();
      // Refresh every 30 seconds
      const interval = setInterval(fetchCounts, 30000);
      return () => clearInterval(interval);
    } else {
      setRequestCount(0);
      setChatCount(0);
    }
  }, [user]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          🍇 NHO
        </Link>
        <div className="navbar-menu">
          {user ? (
            <>
              <Link to="/post-item" className="navbar-link">
                Đăng Món Đồ
              </Link>
              <Link to="/my-items" className="navbar-link">
                Món Đồ Của Tôi
              </Link>
              <Link to="/my-sent-requests" className="navbar-link">
                Đã Xin
              </Link>
              <Link to="/my-requests" className="navbar-link navbar-link-badge">
                Yêu Cầu
                {requestCount > 0 && (
                  <span className="badge badge-pill badge-alert">{requestCount}</span>
                )}
              </Link>
              <Link to="/chat" className="navbar-link navbar-link-badge">
                Chat
                {chatCount > 0 && (
                  <span className="badge badge-pill badge-alert">{chatCount}</span>
                )}
              </Link>
              <span className="navbar-user">Xin chào, {user.username}!</span>
              <button onClick={handleLogout} className="btn btn-outline">
                Đăng Xuất
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="navbar-link">
                Đăng Nhập
              </Link>
              <Link to="/register" className="btn btn-primary">
                Đăng Ký
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

